import { verify } from '../../ducks/EmailVerification.duck';
import { parseVerificationToken } from '../../util/urlHelpers';

// ================ Thunks ================ //

export const loadData = (params, search) => {
  const token = parseVerificationToken(search);
  return verify(token);
};
